<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading" size="large"
		 type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import stringUtils from "../assets/js/stringUtil.js";
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk';

	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess
	} from '@/api/approval'
	import {
		getRelation
	} from '@/api/employee'
	import {
		formatDate
	} from '@/utils/date'
	import {
		getDepartmentRelationByName,
		getDepartmentRelationById,
		getDepartmentInfo,
		getDepartmentRelationByStructs
	} from '@/api/department'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				listLoading: false,
				isDisabled: false,
				formLoading: false
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
			stringUtils.setDeleteIsShow(false);
			stringUtils.setAddIsShow(true);
		},

		methods: { //方法

			clickChoose: async function(dataVal, name) {
				var that = this;
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "multi", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, async function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var DepAssignment = true;
						var department = res.result.departmentList[0]; // 已选的第一个部门列表
						var departments = res.result.departmentList; // 已选的部门列表
						var gradually = [];
						var generalManagers = []; //一级审批
						var chiefInspectors = []; //二级审批
						var threeLevels = []; //三级审批
						var fourLevels = []; //四级审批
						dataVal.Values = [];
						dataVal.Value = "";
						departments.forEach((item, index) => {
							dataVal.Values.push([item.id, item.name]);
							if (index == departments.length - 1) {
								dataVal.Value += `${item.name}`;
							} else {
								dataVal.Value += `${item.name},`;
							}

						})
						dataVal.Value = dataVal.Value.replace("null", "");

						getDepartmentInfo(department.id).then(response => {
							var departFullName = response.Body.FullName;
							if (departFullName.indexOf("非营业部") > -1 || departFullName.indexOf("原友信/风险管理部") > -1) {
								departments.forEach(async dept => {
									getDepartmentInfo(dept.id).then(res => {
										var deptFullName = res.Body.FullName;
										if (departFullName.indexOf("财务中心") > -1) {
											gradually.push(["SC08010029", "朱君"])
										}
										if (departFullName.indexOf("二级市场支援中心") > -1) {
											gradually.push(["SC17004069", "唐媛"])
										}
										if (departFullName.indexOf("综合事务部") > -1) {
											gradually.push(["SC02120002", "卢华"])
										}
										if (departFullName.indexOf("信息中心") > -1) {
											gradually.push(["SC13030113", "周彬"])
										}
										if(departFullName.indexOf("风险管理部")>-1){
											gradually.push(["SC14002350", "蒋燕"])
										}
									})
								})
								that.templateData.TemplateContent.Controls.forEach(item => {
									if (item.Property.Title[0].Text == "部门负责人") {
										item.Values = gradually;
										
									}
								})

							}
							if (departFullName.indexOf("房友圈") > -1) {
								that.templateData.TemplateContent.Controls.forEach(item => {
									if (item.Property.Title[0].Text == "部门负责人") {
										item.Values = [];
										item.Values.push(["SC03080007", "徐菁"])
									}
								});
							}
							if (departFullName.indexOf("按揭金融服务中心") > -1) {
								that.templateData.TemplateContent.Controls.forEach(item => {
									if (item.Property.Title[0].Text == "部门负责人") {
										item.Values = [];
										item.Values.push(["SC04110010", "杨小玉"])
									}
								})
							}
							if (departFullName.indexOf("商业地产部") > -1) {
								that.templateData.TemplateContent.Controls.forEach(item => {
									if (item.Property.Title[0].Text == "部门负责人") {
										item.Values = [];
										item.Values.push(["SC16006360","覃斌"])
									}
                  console.log("debug")
                  console.log(item.Values)
								})
							}
							if (departFullName.indexOf("华西区信息中心") > -1) {
								that.templateData.TemplateContent.Controls.forEach(item => {
									if (item.Property.Title[0].Text == "部门区分") {
										item.Value = 3;
									}
									if (item.Property.Title[0].Text == "部门负责人") {
										item.Values = [];
										item.Values.push(["SC12070037", "杨孟林"])
									}
								})
							}
							if (departFullName.indexOf("华西区总裁办") > -1) {
								that.templateData.TemplateContent.Controls.forEach(item => {
									if (item.Property.Title[0].Text == "部门区分") {
										item.Value = 4;
									}
									if (item.Property.Title[0].Text == "部门负责人") {
										item.Values = [];
										item.Values.push(["SC24000029", "钟志斌"])
									}
								})
							}
							if (departFullName.indexOf("二级市场营运中心") > -1 || departFullName.indexOf("代理") > -1 ||
								departFullName.indexOf("行政支持组") > -1) {
								//遍历所有被选中的部门
								departments.forEach(async dept => {
									getDepartmentInfo(dept.id).then(res => {
										var deptFullName = res.Body.FullName;
										getDepartmentRelationByName(deptFullName, false).then(resp => {
											var bodys = resp.Body;
											bodys.forEach(body => {
												var nodes = body.Nodes;
												nodes.forEach(node => {
													if (node.Items != null) {
														node.Items.forEach(item => {
															if (item.PositionName.indexOf("总经理") > -1 && item.JobLevel < 8) {
																generalManagers.push([item.EmpNo, item.EmpName]);
																that.templateData.TemplateContent.Controls.forEach(item => {
																	if (item.Property.Title[0].Text === "二级审批" && generalManagers.length > 0) {
																		item.Values = generalManagers;
                                    console.log("item.Values")
                                    console.log(item.Values)
																	}
																});
															}
															if (item.PositionName.indexOf("总监") > -1 && item.JobLevel < 8) {
																chiefInspectors.push([item.EmpNo, item.EmpName]);
																that.templateData.TemplateContent.Controls.forEach(item => {
																	if (item.Property.Title[0].Text === "一级审批" && chiefInspectors.length > 0) {
																		item.Values = chiefInspectors;
                                    console.log("item.Values 2")
                                    console.log(item.Values)
																	}
																});
															}
														})
													}
												})
											})
										})
									})
								})

								that.templateData.TemplateContent.Controls.forEach(item => {
									if (item.Property.Title[0].Text == "是否需要总经理审批") {
										item.IsShow = true;
									}
									if (item.Property.Title[0].Text == "部门区分") {
										item.Value = 1;
									}
									if (item.Property.Title[0].Text == "部门负责人") {
										item.Values = [];
										item.Values.push(that.$store.state.defaultMember);
									}
									if (item.Property.Title[0].Text == "(副)总经理" && generalManagers.length > 0) {
										item.Values = generalManagers;
										alert(JSON.stringify(item.Values))
									}
									if (item.Property.Title[0].Text == "总监" && chiefInspectors.length > 0) {
										item.Values = chiefInspectors;
										alert(JSON.stringify(item.Values))
									}
								});
							}
							if (departFullName.indexOf("住宅部") > -1 || departFullName.indexOf("住宅行政支持组") > -1) {
								//遍历所有被选中的部门
								departments.forEach(async dept => {
									getDepartmentInfo(dept.id).then(res => {
										var deptFullName = res.Body.FullName;
										getDepartmentRelationByName(deptFullName, true).then(resp => {
											var bodys = resp.Body;
											bodys.forEach(body => {
												var nodes = body.Nodes;
												nodes.forEach(node => {
													if (node.Items != null) {
														node.Items.forEach(item => {
															if (item.PositionName.indexOf("店董") > -1 && item.JobLevel < 8) {
																generalManagers.push([item.EmpNo, item.EmpName]);
																that.templateData.TemplateContent.Controls.forEach(item => {
																	if (item.Property.Title[0].Text == "一级审批" && generalManagers.length > 0) {
																		item.Values = generalManagers;
																	}
																});
															}
															if (item.PositionName.indexOf("区域董事") > -1 && item.JobLevel < 8) {
																chiefInspectors.push([item.EmpNo, item.EmpName]);
																that.templateData.TemplateContent.Controls.forEach(item => {
																	if (item.Property.Title[0].Text == "二级审批" && chiefInspectors.length > 0) {
																		item.Values = chiefInspectors;
																	}
																});
															}
															if (item.PositionName.indexOf("大区董事") > -1 && item.JobLevel < 8) {
																threeLevels.push([item.EmpNo, item.EmpName]);
																that.templateData.TemplateContent.Controls.forEach(item => {
																	if (item.Property.Title[0].Text == "三级审批" && threeLevels.length > 0) {
																		item.Values = threeLevels;
																	}
																});
															}
															if (item.PositionName.indexOf("总经理") > -1 && item.JobLevel != 10) {
																fourLevels.push([item.EmpNo, item.EmpName]);
																that.templateData.TemplateContent.Controls.forEach(item => {
																	if (item.Property.Title[0].Text == "四级审批" && fourLevels.length > 0) {
																		item.Values = fourLevels;
																	}
																});
															}
														})
													}
												})
											})
										})
									})
								})
								that.templateData.TemplateContent.Controls.forEach(item => {
									if (item.Property.Title[0].Text == "部门区分") {
										item.Value = 0;
									}
								});
							}
						})
					}
				})
			},
			getTemplate: async function() {
				this.listLoading = true;
				getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					controls.TemplateContent.Controls.forEach(async (item) => {
						if (item.Property.Title[0].Text == "其他(原因)") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "流程条件") {
							item.Value = 0;
						}
						if (item.Property.Title[0].Text == "流程编号") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "出差人员") {
							item.Property.Control = "Selector";
							item.IsEmp = true;
							item.filterable = true;
						}
						if (item.Property.Title[0].Text == "合计") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "逐级审批使用") {
							item.IsShow = false;
							item.Values = [];
							item.Values.push(this.$store.state.defaultMember);
						}
						if (item.Property.Title[0].Text == "是否需要总经理审批") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "部门区分") {
							item.Value = 2;
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "部门负责人") {
							item.IsShow = false;
							item.Values = [];
							item.Values.push(this.$store.state.defaultMember)
						}

						if (item.Property.Title[0].Text == "一级审批") {
							item.IsShow = false;
							item.Values = [];
							item.Values.push(this.$store.state.defaultMember)
						}
						if (item.Property.Title[0].Text == "二级审批") {
							item.IsShow = false;
							item.Values = [];
							item.Values.push(this.$store.state.defaultMember)
						}
						if (item.Property.Title[0].Text == "三级审批") {
							item.IsShow = false;
							item.Values = [];
							item.Values.push(this.$store.state.defaultMember)
						}
						if (item.Property.Title[0].Text == "四级审批") {
							item.IsShow = false;
							item.Values = [];
							item.Values.push(this.$store.state.defaultMember)
						}
					});
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
					this.listLoading = false;
				});
			},
			isMobile() {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				)
				return flag;
			},
			getEmployeeRelation() {
				getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal(number, name) {

			},
			getSelectorVal(val, name) {
				if (name == "预计往返交通工具") {
					var controls = this.templateData.TemplateContent.Controls;
					var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
					var option = controlInfo.Config.Selector.Options
						.filter(item => {
							return item.Value[0].Text == "其他" && val.indexOf(item.Key) > -1;
						})[0];
					var control = controls.filter(item => item.Property.Title[0].Text == "其他(原因)")[0];
					if (option != null) {
						control.IsShow = true;
						control.Property.Require = 1;
					} else {
						control.IsShow = false;
						control.Property.Require = 0;
					}
				}
				this.$forceUpdate()
			},
			
			tableOperation(val, type, datas) {
				if (type != "compute") {
					this.tableoperation(val, type, datas, this);
				}
				const accAdd = (arg1, arg2) => {
						var r1, r2, m;
						try {
							r1 = arg1.toString().split(".")[1].length;
						}
						catch (e) {
							r1 = 0;
						}
						try {
							r2 = arg2.toString().split(".")[1].length;
						}
						catch (e) {
							r2 = 0;
						}
						m = Math.pow(10, Math.max(r1, r2));
						return (arg1 * m + arg2 * m) / m;
					}
				let sum = 0.00;
				this.templateData.TemplateContent.Controls.forEach((item) => {
					if (item.Property.Title[0].Text.indexOf("预计往返交通费") > -1 || item.Property.Title[0].Text.indexOf("预计住宿费") > -1 ||
						item.Property.Title[0].Text.indexOf("市内交通费及膳食") > -1) {
						item.Config.Table.Children.forEach((children) => {
							if (children.Property.Title[0].Text == "小计") {
								if (children.Value == null) {
									children.Value = 0;
								}
								sum = accAdd(sum,children.Value)
							}
						})
					}
					if (item.Property.Title[0].Text == "合计") {
						item.Value = sum;
						sum = 0.00
					}
				})
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				isSubmit = true;
				this.formLoading = true;

				var SummaryList = [];
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];

				var control1 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "出差地点/出差目的/办理事项"
				})[0];
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				info.SummaryInfo.push({
					"Text": "内容：" + control1.Value,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);
				var value = null;
				var control3 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "申请时间"
				})[0]
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				info.SummaryInfo.push({
					"Text": "申请时间：" + control3.Value,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);
				this.templateData.SummaryList = SummaryList;

				for (var i = 0; i < this.templateData.TemplateContent.Controls.length; i++) {
					var item = this.templateData.TemplateContent.Controls[i];
					if (item.Property.Title[0].Text == '出差人员') {
            let col = this.templateData.TemplateContent.Controls[i];
						this.templateData.TemplateContent.Controls[i].Property.Control = 'Text';
						this.templateData.TemplateContent.Controls[i].Value = item.Values.toString();
						item.Values = null;
						value = col.value;
						delete col.value;
					}
				}

				// this.templateData.TemplateContent.Controls.forEach(item => {
				// 	if(item.Property.Title[0].Text == "其他"){
				// 		item.Value = JSON.stringify(this.templateData)
				// 	}
				// })

				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.formLoading = false;
				});
			}
		},
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
